import { writable } from "svelte/store"
/**
 * @type {BadgeState}
 */
let BadgeApplicationState = localStorage.getItem("BadgeApp")
if (typeof BadgeApplicationState != "Object") {
  try {
    BadgeApplicationState = JSON.parse(BadgeApplicationState)
    if (!BadgeApplicationState) {
      throw new Error("BadgeApplicationState value is null")
    }
  } catch (error) {
    BadgeApplicationState = {
      name: "",
      baseInfo: {},
      operations: [],
      fonts: [],
      apiFonts: [],
      download: false,
      cursorPosition: {
        x: 0,
        y: 0,
      },
      canvasColor: "transparent",
      activeFontStyles: [],
      activeTextAlign: "center",
      activeTextColor: "#f2072e",
      goBack: false,
      scale: 1,
      resumeModal: false,
      footer: "GENERAL",
    }
  }
}

/**
 * @typedef {Object} BadgeState - it contains the font family,addcustomFonts and newfontlistModals
 * @type {Object}
 *  it contains the font family,addcustomFonts and newfontlistModals
 *
 * @property {Object} name  - overall badge template name
 * @property {Object} baseInfo -canvas Width height value
 * @property {Array} operations -Text and image layer data
 * @property {Array} fonts - Extra added fonts
 * @property {Array} state -which section is activated
 * @property {Object} cursorPosition -to get cursor postion for x and y
 * @property {Number} scale -to increase/decrease a canvas section (pan and zoom option)
 * @property {String} canvasColor -modify the canvas background color
 * @property {Array} activeFontStyles -to store a font weight 
 * @property {Number} activeFontSize -to display the font size 
 * @property {Boolean} goBack -exit modal
 * @property {Boolean} resumeModal -mainain the state
 * @property {Boolean} footer -TO DISPLAY THE FOOTER CONTENT
 * @property {String} activeTextAlign -to ensure right/left/center

 */

/**
 * @type {import("svelte/store").Writable<BadgeState>}
 */

const BadgeState = writable(BadgeApplicationState)

BadgeState.subscribe((value) => {
  localStorage.setItem("BadgeApp", JSON.stringify(value))
})

export default BadgeState
